module.exports = __webpack_public_path__ + "static/media/Van.c33ff11c.svg";